import React from "react";
import { Card } from "antd";
import PropTypes from "prop-types";

const WidgetCard = ({ title, children, styleName, cover, extra, actions, loading }) => {
  return (
    <Card
      title={title}
      actions={actions}
      cover={cover}
      className={`${styleName}`}
      extra={extra}
      style={{
        backgroundColor: "#f2f2f2",
        border: "1px solid #2C2C2C",
        borderRadius: "0 0 10px 10px",
        width:'100%'
      }}
      bordered={true}
      loading = {loading}
    >
      {children}
    </Card>
  );
};

export default WidgetCard;
WidgetCard.defaultProps = {
  styleName: "",
};

WidgetCard.propTypes = {
  title: PropTypes.node,
  extra: PropTypes.node,
  cover: PropTypes.node,
  actions: PropTypes.node,
  children: PropTypes.node.isRequired,
};
